import { Drawer } from '@openx/components-core/lib/Drawer/Drawer.tsx';
import type { SupplementalAdQuality } from '@openx/types/deal.ts';
import { useCallback, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import type { SupplementalAdQualityFormState } from './constants.ts';
import { SupplementalAdQualityForm } from './SupplementalAdQualityForm.tsx';
import { mapFromFormState, mapToFormState } from './utils.ts';

interface SupplementalAdQualityDrawerProps {
  currentState: SupplementalAdQuality | null;
  onClose: () => void;
  onApply: (state: SupplementalAdQuality) => void;
}

export function SupplementalAdQualityDrawer(props: SupplementalAdQualityDrawerProps) {
  const { currentState, onClose, onApply } = props;
  const initialValues = useMemo(() => mapToFormState(currentState), [currentState]);

  const formMethods = useForm<SupplementalAdQualityFormState>({
    defaultValues: initialValues,
    mode: 'all',
  });

  const onSubmit = useCallback(values => onApply(mapFromFormState(values)), [onApply]);

  return (
    <Drawer open onClose={onClose}>
      <FormProvider {...formMethods}>
        <form autoComplete="off" noValidate>
          <SupplementalAdQualityForm onCancel={onClose} onSubmit={formMethods.handleSubmit(onSubmit)} />
        </form>
      </FormProvider>
    </Drawer>
  );
}
